import { useEffect, useState } from "react";
import { IMG_SAFETY } from "../lib/images";
import { SectionHeading } from "../components/SectionHeading";
import { IconFromKey } from "../lib/iconMap";
import { api } from "../lib/api";

export default function Safety() {
  const [points, setPoints] = useState([]);
  const [conductParagraphs, setConductParagraphs] = useState([]);

  useEffect(() => {
    api
      .get("/content/safety")
      .then(({ data }) => {
        setPoints(data.points);
        setConductParagraphs(data.conduct_paragraphs);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="safety-page">
      <section className="relative min-h-[380px] flex items-center">
        <div className="absolute inset-0">
          <img src={IMG_SAFETY} alt="People gathered safely at a public lake overlook" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-midnight-black/65" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <p className="text-stranger-orange font-bold tracking-widest uppercase text-sm mb-4">The mystery should be exciting.</p>
          <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl">The safety should never be mysterious.</h1>
        </div>
      </section>

      <section className="bg-clean-white py-20">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <SectionHeading eyebrow="How We Keep It Safe" title="Safety at Stranger Sessions" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {points.map((p) => (
              <div key={p.id} className="border border-soft-gray rounded-2xl p-6" data-testid={`safety-point-${p.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <IconFromKey iconKey={p.icon_key} className="w-7 h-7 text-stranger-orange mb-4" />
                <h3 className="font-extrabold uppercase text-sm tracking-wide mb-2">{p.title}</h3>
                <p className="text-sm text-midnight-black/70 font-medium leading-relaxed">{p.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-warm-white py-16">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center space-y-4">
          <h2 className="font-extrabold uppercase text-xl">Conduct Expectations</h2>
          {conductParagraphs.map((p, i) => (
            <p key={i} className="text-midnight-black/75 font-medium leading-relaxed">
              {p}
            </p>
          ))}
        </div>
      </section>
    </div>
  );
}
